// Friluftsområden – konfigurationsdriven områdesöversikt.
//
// Att lägga till ett nytt område kräver bara en post här. Bilden/PDF:en speglas
// först till R2 via mod-verktyget "Media spiegeln" (se ModMediaMirror.js); URL:en
// klistras sedan in nedan. Inga DB-ändringar krävs.
//
// Källans namn och länk visas alltid synligt i UI:t som upphovsattribution.

import { PDF_KARTA_SILSJO, PDF_KARTA_SILSJO_ORIGIN } from "./trails";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const AREAS = {
  silsjonas: {
    slug: "silsjonas",
    title: "Silsjönäs stigar",
    breadcrumb: "Friluftsliv · Vandringsleder",
    intro:
      "Sex markerade leder med Silsjönäs bygdegård som naturlig startpunkt. " +
      "Stigarna går genom skog, över myrar och förbi historiska lämningar – " +
      "från korta promenader till heldagsturer. Skoterleden binder samman " +
      "Backe, Ramsele och Mörtsjön.",
    mapImage: PDF_KARTA_SILSJO,
    mapImageType: "jpg",
    downloadName: "silsjonas-stigar.jpg",
    sourceName: "backe.nu/vandringseldorado",
    sourceUrl: "https://www.backe.nu/sv/vandringseldorado",
    sourceImageOrigin: PDF_KARTA_SILSJO_ORIGIN,
    googleMaps: {
      lat: 63.7638,
      lng: 16.4,
      label: "Silsjönäs bygdegård",
    },
    // Återanvänder existerande led-data via TRAILS_BY_AREA-nyckel.
    trailAreas: ["Silsjönäs"],
    pois: [
      { key: "vindskydd", label: "Vindskydd" },
      { key: "stuga", label: "Jaktcampen / stugor" },
      { key: "fangstgrop", label: "Fångstgrop" },
      { key: "skoterled", label: "Skoterled" },
    ],
    notis:
      "Leder och avstånd kan variera. Ta med karta och visa hänsyn till naturen. " +
      "På kartan finns även vindskydd, jaktcampen och en fångstgrop markerade " +
      "som intressanta stopp.",
  },

  "fjallsjo-vandringseldorado": {
    slug: "fjallsjo-vandringseldorado",
    title: "Fjällsjö Vandringseldorado",
    breadcrumb: "Friluftsliv · Vandringsleder",
    intro:
      "Fjällsjös centrala vandringsledsnät – ett tiotal markerade leder runt " +
      "Backe och Jansjö med Fjällsjöälven som vattenstråk. Från korta byastigar " +
      "och elljusspår till längre upptäcksrutter över sandrevlar och fäbodvallar.",
    mapImage: `${BACKEND}/api/uploads/friluftsliv-fjallsjo-vandringseldorado-preview.jpg`,
    mapImageType: "pdf",
    downloadUrl: `${BACKEND}/api/uploads/friluftsliv-fjallsjo-vandringseldorado.pdf`,
    downloadName: "fjallsjo-vandringseldorado.pdf",
    sourceName: "backe.nu/vandringseldorado",
    sourceUrl: "https://www.backe.nu/sv/vandringseldorado",
    sourceImageOrigin: "https://backe.nu/sites/default/files/fileuploads/vandringseldoradokarta.pdf",
    googleMaps: {
      lat: 63.819,
      lng: 16.397,
      label: "Backe centrum",
    },
    // Återanvänder de befintliga Backe- och Jansjö-lederna ur trails.js.
    trailAreas: ["Backe", "Jansjö"],
    pois: [
      { key: "parkering", label: "Parkering" },
      { key: "vindskydd", label: "Vindskydd" },
      { key: "wc", label: "Offentlig toalett" },
      { key: "turistinfo", label: "Turistinformation" },
      { key: "stuga", label: "Stuga" },
      { key: "kulturhist", label: "Kulturhistoriska lämningar" },
      { key: "hallmalning", label: "Hällmålning" },
    ],
    notis:
      "Leder och avstånd kan variera. Ta med karta och visa hänsyn till naturen. " +
      "På kartan finns även parkering, vindskydd, offentlig toalett, " +
      "turistinformation och kulturhistoriska lämningar markerade.",
  },
};

export function findAreaBySlug(slug) {
  return AREAS[slug] || null;
}

export const AREA_LIST = Object.values(AREAS);
